import { Key } from 'react'
import { capitalize } from 'lodash'
import { Item as MenuItem } from '@react-stately/collections'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down__12.svg'
import { AccessDropdownProps } from '../Types'
import Styles from '../ShareSheet.module.scss'
import { Button } from 'blaze-ui/Button'

const itemText = {
  transfer: 'Transfer Ownership',
  takeOwnership: 'Take Ownership',
  read: 'Read',
  edit: 'Edit',
  comment: 'Comment',
  remove: 'Remove',
}

export const AccessDropdown = ({
  currentPermission,
  handleClick,
  options,
  disabled,
  variant = 'editor',
  size = 'md',
}: AccessDropdownProps) => {
  return (
    <MenuTrigger placement="bottom-end" popoverClassName={Styles.popoverMenu}>
      <Button variant={variant} size={size} endIcon={ChevronDown} isDisabled={disabled}>
        {capitalize(currentPermission)}
      </Button>
      <Menu
        aria-label="Permission Options"
        onAction={handleClick}
        autoFocus="first"
        shouldFocusWrap
        selectedKeys={new Set<Key>([currentPermission])}
        selectionMode="single"
        showCheckmark={false}
      >
        {options.map((option) => (
          <MenuItem key={option} textValue={option}>
            {itemText[option]}
          </MenuItem>
        ))}
      </Menu>
    </MenuTrigger>
  )
}
